import { useEffect, useState } from "react";

interface Props extends React.HTMLAttributes<HTMLElement> {
    size?: number;
    alt?: string;
    children?: React.ReactNode;
    invertColor?: boolean;
    active?: boolean;
    name?: string;
    opacity?: number;
}

// Checa uma vez fora do componente para não repetir por instância
let fontLoadPromise: Promise<boolean> | null = null;

function getMaterialSymbolsReady(): Promise<boolean> {
    if (!fontLoadPromise) {
        fontLoadPromise = document.fonts
            .load('12px "Material Symbols Rounded"')
            .then(() => document.fonts.check('12px "Material Symbols Rounded"'))
            .catch(() => false);
    }
    return fontLoadPromise;
}

export const Icon = ({
    alt,
    children,
    invertColor = false,
    active,
    name,
    size,
    opacity,
    ...rest
}: Props) => {
    // Verifica já na inicialização — se estiver em cache, não pisca
    const [fontReady, setFontReady] = useState(() =>
        document.fonts.check('12px "Material Symbols Rounded"')
    );

    useEffect(() => {
        if (fontReady) return;
        getMaterialSymbolsReady().then(setFontReady);
    }, []);

    // if (name && fontReady) {
    //     return (
    //         <span
    //             {...rest}
    //             className={`material-symbols-rounded ${rest.className ?? ""}`}
    //             key={active ? "filled" : "outline"}
    //             style={{
    //                 opacity: active ? 1 : 0.7,
    //                 color: rest.color
    //                     ? rest.color
    //                     : invertColor
    //                     ? "#000"
    //                     : "#fff",
    //                 fontSize: size,
    //                 fontVariationSettings: active ? "'FILL' 1" : "'FILL' 0'",
    //             }}
    //         >
    //             {name}
    //         </span>
    //     );
    // }

    // Fallback para Lucide/feather enquanto a fonte não carrega (ou se falhar)
    return <>{children}</>;
};